import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'gt-user-greeting',
    template: `
      <div style="height: 45px;" [ngClass]="userGreeting?.class">
      </div>
      <h4 style="font-weight: 100; font-size: 20px" class="text-white mt-2">
         {{userGreeting?.msg}}
      </h4>`,
    imports: [NgClass]
})
export class GtUserGreetingComponent {
  @Input()
  public time = new Date();

  public get userGreeting(): any {
    const hrs = this.time.getHours();

    const morning = 5;
    const noon = 12;
    const evening = 17;

    if (hrs >= evening || hrs < morning) {
      return {
        msg: 'GOOD EVENING',
        class: 'gt-evening'
      };
    }
    if (hrs < noon) {
      return {
        msg: 'GOOD MORNING',
        class: 'gt-morning'
      };
    }
    if (hrs === noon) {
      return {
        msg: 'GOOD NOON',
        class: 'gt-noon'
      };
    }
    if (hrs < evening) {
      return {
        msg: 'GOOD AFTERNOON',
        class: 'gt-noon'
      };
    }
  }
}
